import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import PropTypes from 'prop-types';
import { formatPercentWithCount } from '../../../utility';

const ButterflyChart = ({
    chartOptions,
    seriesData,
    categories

}) => {
    const pointTooltipFormatter = function (color) {
        const { point } = this;
        if (point) {
            const { series } = point;
            const value = Number(point.y);
            const { name } = series;
            const count = series.userOptions?.counts?.[point.index];
            const colorDot = '<span style="color:' + color + '">\u25CF</span> ';
            return colorDot + name + ': ' + formatPercentWithCount(value, count);
        }
    };

    const options = {
        chart: { type: 'bar' },
        lang: { noData: 'No data to display' },
        noData: {
            style: {
                fontWeight: 'bold',
                fontSize: '15px',
                color: '#303030'
            }
        },
        title: { text: null },
        subtitle: { text: null },
        navigation: { buttonOptions: { enabled: false } },
        credits: { enabled: false },
        legend: {
            enabled: true,
            verticalAlign: 'top',
            y: 20
        },
        tooltip: {
            shared: true,
            backgroundColor: '#000',
            borderColor: 'black',
            borderRadius: 10,
            borderWidth: 0,
            style: { color: '#fff' },
            formatter: function () {
                let tooltipText = '<b>' + this.x + '</b><br/>';
                if (this.points) {
                    this.points.forEach((point) => {
                        const formattedPoint = pointTooltipFormatter.call(point, point.color);
                        if (formattedPoint) {
                            tooltipText += formattedPoint + '<br/>';
                        }
                    });
                }
                return tooltipText;
            }

        },
        xAxis: [
            {
                categories: categories,
                reversed: true,
                labels: {
                    align: 'center',
                    step: 1,
                    reserveSpace: false,
                    x: -5,
                    style: {
                        color: '#AD509E',
                        fontSize: '12px',
                        fontWeight: 700
                    }
                },
                lineWidth: 0,
                tickLength: 0,
                left: '50%'
            }
           
        ],
        yAxis: [
            {
                title: {
                    text: '% HCPs', 
                    useHTML: true,
                    align: 'middle'
                },
                labels: { format: '{value}%' },
                reversed: true,
                left: 0,
                width: '45%',
                offset: 0,
                tickAmount: 5,
                tickInterval: 20
            },
            {
                title: {
                    text: '% HCPs', 
                    useHTML: true,
                    align: 'middle'
                    // x: -125,
                },
                labels: { format: '{value}%' },
                left: '55%',
                width: '45%',
                offset: 0,
                tickAmount: 5,
                tickInterval: 20
            }
        ],

        plotOptions: {
            series: {
                stacking: 'normal',
                dataLabels: {
                    enabled: true,
                    style: {
                        color: '#FFF',
                        borderWidth: 0,
                        textOutline: 0,
                        textShadow: false
                    },
                    formatter: function () {
                        return this.y + '%';
                    }
                },
                borderRadius: 3,
                groupPadding: 0.1, 
                pointPadding: 0.05, 
                states: { hover: { enabled: false } }
            }
        },
        series: seriesData
    };

    return (
        <HighchartsReact
            containerProps={{ style: { height: 'auto', width: '100%' } }}
            highcharts={Highcharts}
            options={options}
        />
    );
};

ButterflyChart.propTypes = {
    chartOptions: PropTypes.object.isRequired,
    seriesData: PropTypes.array.isRequired,
    categories: PropTypes.array
};

export default ButterflyChart;
